import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { useShallow } from "zustand/react/shallow";

import { PagesState, PagesStore } from "./pages_store_types";

const INITIAL_STATE = {
  pages: {}
} satisfies PagesState;

/**
 * @deprecated
 */
export const usePagesStore = create<PagesStore>()(
  immer((set) => ({
    ...INITIAL_STATE,
    actions: {
      createPage: ({ key, data = {} }) =>
        set((state) => {
          state.pages[key] = { ...data };
        }),
      updatePage: ({ key, data }) =>
        set((state) => {
          state.pages[key] = { ...(state.pages[key] ?? {}), ...data };
        }),
      removePage: (key) =>
        set((state) => {
          delete state.pages[key];
        }),
      reset: () =>
        set((state) => {
          Object.assign(state, INITIAL_STATE);
        })
    }
  }))
);

/**
 * @deprecated
 */
export const usePagesStoreActions = () => usePagesStore(useShallow((state) => state.actions));
